<script setup lang="ts">
import type { Nullish } from "@ca/types/util";

import { computed } from "vue";

const props = defineProps<{
	status: Nullish<string>;
}>();

const statusMeta = computed(() => {
	if (!props.status || props.status === "complete") {
		return null;
	}
	const config = {
		"en_route": {
			color: "success",
			icon: "mdi-airplane-marker",
			label: "En Route",
			status: "en_route",
		},
		"scheduled": {
			color: "info",
			icon: "mdi-clock-outline",
			label: "Scheduled",
			status: "scheduled",
		},
		"scheduled_unflown": {
			color: "neutral",
			icon: "mdi-calendar-remove-outline",
			label: "Cancelled",
			status: "scheduled_unflown",
		},
		"started_outcome_unknown": {
			color: "error",
			icon: "mdi-crosshairs-question",
			label: "Outcome Unknown",
			status: "started_outcome_unknown",
		},
	} as const;
	return config[props.status as keyof typeof config] ?? null;
});
</script>

<template>
  <UBadge
    v-if="statusMeta"
    :icon="statusMeta.icon"
    :label="statusMeta.label"
    size="sm"
    :color="statusMeta.color"
    variant="subtle"
  />
</template>